import { UserService } from '../../../common/service/user.service';
import { Component, OnInit, signal } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ServiceCase } from '../model/service-case';
import { ServiceCaseService } from '../service-case.service';
import { ServiceCaseStatus } from '../enum/service-case-status.enum';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environment/environment';
import { PageResult } from '../../../common/model/PageResult';
import { ServiceCaseQuery } from '../model/service-case-query';
import { ServiceCaseStatusPipe } from '../pipes/service-case-status.pipe';
import { DatePipe, NgStyle } from '@angular/common';
import { TranslationService } from '../../../common/service/translate.service';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { EnumConverter } from '../../../common/helper/enum-converter';
import { Skeleton } from 'primeng/skeleton';
import { TableFilterIconComponent } from '../../../common/component/table-filter-icon/table-filter-icon.component';
/**
 * Component for displaying and managing delivery notes in a table.
 */
@Component({
  selector: 'gate-customer-case-table',
  standalone: true,
  imports: [NgStyle, DatePipe, TableModule, TagModule, ButtonModule, TranslatePipe, ServiceCaseStatusPipe, Select, FormsModule, Skeleton, TableFilterIconComponent],
  templateUrl: './customer-case-table.component.html',
  styleUrl: './customer-case-table.component.scss',
})
export class CustomerCaseTableComponent implements OnInit {
  public serviceCases = signal<ServiceCase[]>([]); // Signal to hold the list of delivery notes
  public isLoading = signal<boolean>(false); // Signal to track loading state
  public totalRecords: number = 0; // Total number of records
  itemsPerPage = environment.DefaultItemsPerPage;
  private serviceCaseQuery!: ServiceCaseQuery;
  serviceCaseStatuses: any[] = [];
  constructor(
    private serviceCaseService: ServiceCaseService,
    private userService: UserService,
    private translate: TranslateService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.mapServiceCaseStatusEnumToArray();
    this.initServiceCases(); // Initialize delivery notes list
    this.translate.onLangChange.subscribe((e) => this.onLanguageChanged.call(this, e));
  }

  private onLanguageChanged(ev: any) {
    this.mapServiceCaseStatusEnumToArray();
  }

  private getCustomerIncidents() {
    this.totalRecords = 0;
    this.isLoading.set(true); // Set loading state to true
    this.serviceCaseService
      .getCustomerIncidents(this.serviceCaseQuery)
      .then((result: PageResult<ServiceCase>) => {
        if (result) {
          this.totalRecords = result.count; // Update total records count
          this.serviceCases.set([...result.items]); // Update the serviceCases signal
        }
        this.isLoading.set(false); // Set loading state to false
      })
      .catch((error) => {
        this.isLoading.set(false); // Set loading state to false on error
        console.error('Error fetching serviceCases:', error); // Log error to console
      });
  }

  /**
   * Initializes the serviceCases list by setting default values and fetching delivery notes.
   */
  private initServiceCases() {
    this.serviceCaseQuery = new ServiceCaseQuery();
    this.serviceCaseQuery.userEmail = this.userService.getUserEmail();
    this.getCustomerIncidents(); // Fetch delivery notes with default filters
  }
  /**
   * Returns the severity level for a given status.
   * @param status - The status to check
   * @returns The severity level as a string union type
   */
  public getSeverity(status: ServiceCaseStatus):
    | 'success'
    | 'secondary'
    | 'info'
    | 'warn'
    | 'danger'
    | 'contrast'
    | undefined {
    return this.serviceCaseService.getServiceCaseStatusSeverity(status);
  }

  public isEmpty(value: any): boolean {
    return value == null || value.length < 1 || value <= 0;
  }

  private mapServiceCaseStatusEnumToArray(): void {
    var statusPipe = new ServiceCaseStatusPipe();
    var serviceCaseStatuses = EnumConverter.ConvertEnumToArray(ServiceCaseStatus);
    serviceCaseStatuses.forEach((element) => {
      element.key = this.translationService.translateKey(statusPipe.transform(element.value));
    });
    this.serviceCaseStatuses = serviceCaseStatuses;
  }
}
